import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import { Link } from "react-router-dom";
import BreakPoints from "src/general/constants/breakPoints";
import { text } from "stream/consumers";

export const StyledLink = styled(Link, {
	shouldForwardProp: (prop) => prop !== "isActive",
})<{ theme: any; isActive: boolean }>(({ theme, isActive }) => ({
	display: "flex",
	alignItems: "center",
	gap: theme.spacing(1),
	padding: `${theme.spacing(1)} 0`,
	width: "100%",

	[`@media  (min-width: ${BreakPoints.TABLET_1023}px) and ( max-width: ${BreakPoints.LARGE_1439}px)`]:
		{
			backgroundColor: isActive ? theme.palette.primary.main : "transparent",
			borderRadius: "12px",
			gap: "4px",
			padding: "8px",
			flexDirection: "column",
			alignItems: "center",
			justifyContent: "center",
		},
}));

export const StyledTypography = styled(Typography)<{
	theme: any;
	isActive: boolean;
}>(({ theme, isActive }) => ({
	...theme.typography.body1,
	color: isActive ? theme.palette.primary.main : theme.palette.text.primary,

	[`@media  (min-width: ${BreakPoints.TABLET_1023}px) and ( max-width: ${BreakPoints.LARGE_1439}px)`]:
		{
			...theme.typography.body2,
			color: isActive
				? theme.palette.common.white
				: theme.palette.text.secondary,
			backgroundColor: isActive ? theme.palette.primary.main : "transparent",
			textAlign: "center",
		},
}));
